import { doc, setDoc, deleteDoc, collection, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import { getDeviceId } from './deviceApprovalService';

/**
 * FCM 토큰을 Firestore에 저장
 * 문서 ID = {uid}_{platform}_{deviceId}
 *   - deviceId(기기별 localStorage 발급)를 넣어 한 아이디로 여러 기기(폰 2대 등) 로그인 시
 *     기기마다 토큰이 따로 저장된다 → 발송 함수가 uid의 토큰 전부에 보내므로 전 기기 동시 수신.
 *   - (예전엔 {uid}_{platform} 이라 같은 기종 2대면 뒤 기기가 앞 기기 토큰을 덮어써 1대만 울렸음)
 */
export const saveFcmToken = async (uid, token, platform = 'android') => {
  if (!uid || !token) return;
  const deviceId = getDeviceId();
  const tokenId = `${uid}_${platform}_${deviceId}`;

  // 같은 기기에서 계정 전환/토큰 갱신 시 동일 token 이 옛 문서에 남아있으면,
  // 발송 코드가 그 토큰으로 중복 발송한다. token 기준으로 다른 문서가 있으면 정리.
  // (token 은 기기마다 고유하므로 다른 기기 문서를 잘못 지우지 않음)
  try {
    const dupSnap = await getDocs(query(collection(db, 'fcmTokens'), where('token', '==', token)));
    for (const d of dupSnap.docs) {
      if (d.id !== tokenId) await deleteDoc(d.ref);
    }
  } catch (_) {}

  await setDoc(doc(db, 'fcmTokens', tokenId), {
    uid,
    token,
    platform,
    deviceId,
    updatedAt: serverTimestamp(),
  });
};

/**
 * FCM 토큰 삭제 (로그아웃 시) — 현재 기기 것만 삭제.
 * (uid 전체를 지우면 같은 아이디로 로그인된 다른 기기 푸시까지 끊기므로 deviceId 로 한정)
 */
export const removeFcmToken = async (uid) => {
  if (!uid) return;
  const deviceId = getDeviceId();
  try {
    const q = query(
      collection(db, 'fcmTokens'),
      where('uid', '==', uid),
      where('deviceId', '==', deviceId),
    );
    const snap = await getDocs(q);
    for (const d of snap.docs) {
      await deleteDoc(d.ref);
    }
  } catch (_) {}
};
